export { default } from './reset-password-form';
